import FieldController from '../field.controller';

class YesNoFieldController extends FieldController {
  constructor($scope, $q, $translate, $log) {
    "ngInject";
    super($scope, $q, $translate, $log);
    this._options = [
      {id: 't', name: 'YES'},
      {id: 'f', name: 'NO'},
    ];
  }

  $onInit() {
    super.$onInit();

    const keysToTranslate = this.options.map(opt => opt.name);
    const translatePromises = keysToTranslate.map(key => this.$translate(key));
    return this.$q.all(translatePromises)
      .then(translations => {
        for (let idx = 0; idx < this.options.length; idx++) {
          this.options[idx].name = translations[idx];
        }
      });
  }

  get options() {
    return this._options;
  }
}

export default YesNoFieldController;
